import { isNil } from 'ramda';

function roundToZero(s: number) {
  return s > 0 ? Math.floor : Math.ceil;
}

function parseTime(s: number) {
  return [
    /* minutes: */ roundToZero(s)((s / 60) % 60),
    /* seconds: */ roundToZero(s)(s % 60),
  ];
}

export function formatTimeToMinutes(s: number) {
  const timeString = parseTime(s).reduce(
    (acc, x) => (acc
      ? `${acc}:${!isNil(x) ? String(x).padStart(2, '0') : ''}`
      : acc + (x ? String(x).padStart(2 - Number(!acc), '0') : '')),
    ''
  );

  return timeString;
}

export function convertToMinutesAndSeconds(seconds: number) {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`;
}
